import { LogicBlockOrV2 } from 'dashboard/lib/workflows';

///////////////////
// InquiryFunnels 2.0 //
///////////////////

/*
 * JSON Logic compatible rules that have variable names compatible with
 * ObjectVariableResolver in the backend.
 */
export interface InquiryFunnelConditional {
  token: string;
  name: string;
  rules?: LogicBlockOrV2;
}

export interface InquiryFunnelElse {
  token: string;
  name: 'Else';
  rules: true;
}

export enum InquiryFunnelStepType {
  Action = 'InquiryFunnel-step/action',
  Conditional = 'InquiryFunnel-step/conditional',
}

export interface InquiryFunnelStepMetrics {
  value: number;
  percentage: number;
}

export interface InquiryStepWithMetrics {
  metrics: InquiryFunnelStepMetrics;
}

export interface InquiryFunnelStepBase extends InquiryStepWithMetrics {
  token: string;
  type: InquiryFunnelStepType;
  name: string;
  isTerminal: boolean;
}

export interface InquiryFunnelStepAction extends InquiryFunnelStepBase {
  type: InquiryFunnelStepType.Action;
}

export interface InquiryFunnelStepConditional extends InquiryFunnelStepBase {
  type: InquiryFunnelStepType.Conditional;
  branches: InquiryFunnelStep[][];
  conditionals: (InquiryFunnelConditional | InquiryFunnelElse)[];
}

// Steps that can actually be added by UI
export type InquiryFunnelStep = InquiryFunnelStepAction | InquiryFunnelStepConditional;
